import React from 'react';
import { findDOMNode } from 'react-dom';

import { IconName } from './';
import { icons } from './icon';

export interface Props {
  children?: any;
  color?: string;
  icon?: IconName;
  size?: number;
}

export interface Size {
  width: number;
  height: number;
}
export interface State {
  absoluteSize: Size;
  refresh: boolean;
}

class IconChild extends React.Component<Props, State> {
  private el: SVGElement;

  constructor(props) {
    super(props);
    this.state = {
      absoluteSize: null,
      refresh: true,
    };
  }

  public getSize(): Size {
    const el = findDOMNode(this.el) as Element;
    const mySize = el.getBoundingClientRect();

    return {
      width: mySize.width,
      height: mySize.height,
    };
  }

  public componentDidMount() {
    const absoluteSize = this.getSize();
    this.setState({ absoluteSize });
  }

  public componentDidUpdate(prevProps, prevState) {
    const { refresh } = this.state;
    const iconChanged = this.props.icon !== prevProps.icon;
    if (!refresh && iconChanged) {
      return this.setState({ refresh: true });
    }
    if (refresh) {
      const absoluteSize = this.getSize();
      return this.setState({ refresh: false, absoluteSize });
    }
  }

  public render() {
    const { absoluteSize, refresh } = this.state;
    const { icon, size, children } = this.props;
    let transform;
    if (absoluteSize && !refresh) {
      const scaleX = (size / absoluteSize.width) * 0.8;
      const scaleY = (size / absoluteSize.height) * 0.8;
      const scale = Math.min(scaleX, scaleY);
      const translateX = (absoluteSize.width * scaleX) / 2;
      const translateY = (absoluteSize.height * scaleY) / 2;
      transform = `translate(-${translateX}, -${translateY}), scale(${scale})`;
    }

    return (
      <g
        className="icon"
        ref={el => (this.el = el)}
        transform={transform || ''}
      >
        {icon ? icons[icon] : children}
      </g>
    );
  }
}

export default IconChild;
